import api from '../config/axiosConfig';

export const dropboxService = {
  // Obtener configuración actual de Dropbox
  getConfig: async () => {
    try {
      const response = await api.get('/dropbox');
      return response.data;
    } catch (error) {
      console.error('Error al obtener configuración de Dropbox:', error);
      throw error;
    }
  },

  // Obtener configuración activa completa de Dropbox (incluyendo access token)
  getActiveConfig: async () => {
    try {
      console.log('🔍 Obteniendo configuración activa completa...');
      const response = await api.get('/dropbox/active-config');
      console.log('✅ Configuración activa obtenida:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener configuración activa de Dropbox:', error);
      throw error;
    }
  },

  // Configurar nueva aplicación de Dropbox
  setConfig: async (configData) => {
    try {
      const response = await api.post('/dropbox', configData);
      return response.data;
    } catch (error) {
      console.error('Error al configurar Dropbox:', error);
      throw error;
    }
  },

  // Confirmar configuración con código de autorización
  confirmConfig: async (confirmData) => {
    try {
      const response = await api.post('/dropbox/confirm', confirmData);
      return response.data;
    } catch (error) {
      console.error('Error al confirmar configuración de Dropbox:', error);
      throw error;
    }
  },

  // Confirmar configuración con access token directo
  confirmConfigWithToken: async (tokenData) => {
    try {
      const response = await api.post('/dropbox/confirm-token', tokenData);
      return response.data;
    } catch (error) {
      console.error('Error al confirmar configuración con token:', error);
      throw error;
    }
  },

  // Probar conexión con Dropbox
  testConnection: async () => {
    try {
      const response = await api.post('/dropbox/test');
      return response.data;
    } catch (error) {
      console.error('Error al probar conexión con Dropbox:', error);
      throw error;
    }
  },

  // Sincronizar archivos manualmente
  syncFiles: async () => {
    try {
      console.log('🔄 Sincronizando archivos...');
      const response = await api.post('/dropbox/sync');
      console.log('✅ Sincronización exitosa:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al sincronizar archivos:', error);
      throw error;
    }
  },

  // Obtener información de almacenamiento
  getStorageInfo: async () => {
    try {
      console.log('🔄 Obteniendo información de almacenamiento...');
      const response = await api.get('/dropbox/storage');
      console.log('✅ Información de almacenamiento obtenida:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener información de almacenamiento:', error);
      throw error;
    }
  },

  // Obtener archivos recientes
  getRecentFiles: async () => {
    try {
      console.log('🔄 Obteniendo archivos recientes...');
      const response = await api.get('/dropbox/files/recent');
      console.log('✅ Archivos recientes obtenidos:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener archivos recientes:', error);
      throw error;
    }
  },

  // Subir archivo específico
  uploadFile: async (fileData) => {
    try {
      console.log('🔄 Subiendo archivo a Dropbox...');
      const response = await api.post('/dropbox/upload', fileData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('✅ Archivo subido exitosamente:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al subir archivo a Dropbox:', error);
      throw error;
    }
  },

  // Eliminar archivo de Dropbox
  deleteFile: async (fileName) => {
    try {
      console.log('🔄 Eliminando archivo de Dropbox:', fileName);
      const response = await api.delete(`/dropbox/files/${fileName}`);
      console.log('✅ Archivo eliminado exitosamente:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al eliminar archivo de Dropbox:', error);
      throw error;
    }
  },

  // Obtener enlace de descarga
  getDownloadLink: async (fileName) => {
    try {
      console.log('🔄 Obteniendo enlace de descarga para:', fileName);
      const response = await api.get(`/dropbox/files/${fileName}/download`);
      console.log('✅ Enlace de descarga obtenido:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener enlace de descarga:', error);
      throw error;
    }
  },

  // Obtener la ruta base configurada
  getBasePath: async () => {
    try {
      console.log('🔄 Obteniendo ruta base de Dropbox...');
      const response = await api.get('/dropbox/base-path');
      console.log('✅ Ruta base obtenida:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener la ruta base:', error);
      // Return default path if there's an error
      return { basePath: '/CONEM_Documents' };
    }
  },

  // Actualizar la ruta base
  updateBasePath: async (basePath) => {
    try {
      console.log('🔄 Actualizando ruta base a:', basePath);
      const response = await api.put('/dropbox/base-path', { basePath: basePath });
      console.log('✅ Ruta base actualizada:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al actualizar la ruta base:', error);
      throw error;
    }
  },

  // Actualizar configuración de guardado automático
  updateAutomaticSave: async (automaticSave) => {
    try {
      console.log('🔄 Actualizando guardado automático a:', automaticSave);
      const response = await api.put('/dropbox/automatic-save', { automaticSave: automaticSave });
      console.log('✅ Guardado automático actualizado:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al actualizar guardado automático:', error);
      throw error;
    }
  },

  // Método de diagnóstico para probar conectividad del backend
  testBackendConnection: async () => {
    try {
      console.log('🔍 DIAGNÓSTICO: Probando conectividad del backend...');
      
      // Intentar hacer una petición simple al endpoint de configuración
      const response = await api.get('/dropbox');
      
      console.log('✅ DIAGNÓSTICO: Backend CONECTADO y funcionando');
      console.log('   Status:', response.status);
      console.log('   Data:', response.data);
      
      return {
        connected: true,
        status: response.status,
        message: 'Backend conectado y funcionando correctamente',
        data: response.data
      };
      
    } catch (error) {
      console.log('📊 DIAGNÓSTICO: Analizando respuesta del backend...');
      
      if (error.response) {
        // El servidor respondió con un código de estado que está fuera del rango de 2xx
        console.log('⚠️ DIAGNÓSTICO: Backend ACTIVO pero con restricciones');
        console.log('   Status:', error.response.status);
        console.log('   StatusText:', error.response.statusText);
        console.log('   Data:', error.response.data);
        
        if (error.response.status === 401) {
          return {
            connected: true,
            status: error.response.status,
            message: 'Backend activo - Requiere autenticación JWT',
            requiresAuth: true,
            data: error.response.data
          };
        } else {
          return {
            connected: true,
            status: error.response.status,
            message: `Backend activo - Error ${error.response.status}: ${error.response.statusText}`,
            data: error.response.data
          };
        }
      } else if (error.request) {
        // La petición fue hecha pero no se recibió respuesta
        console.log('❌ DIAGNÓSTICO: Backend NO DISPONIBLE');
        console.log('   Request:', error.request);
        
        return {
          connected: false,
          status: null,
          message: 'Backend no disponible - Sin respuesta del servidor',
          error: 'No response from server'
        };
      } else {
        // Algo pasó al configurar la petición que activó un Error
        console.log('❌ DIAGNÓSTICO: Error en la configuración de la petición');
        console.log('   Message:', error.message);
        
        return {
          connected: false,
          status: null,
          message: 'Error de configuración en la petición',
          error: error.message
        };
      }
    }
  },

  // Renovar token de acceso de Dropbox
  refreshToken: async () => {
    try {
      const response = await api.post('/dropbox/refresh-token');
      return response.data;
    } catch (error) {
      console.error('Error al renovar token de Dropbox:', error);
      throw error;
    }
  },

  // Obtener configuración completa incluyendo token
  getConfigWithToken: async () => {
    try {
      const response = await api.get('/dropbox/config-with-token');
      return response.data;
    } catch (error) {
      console.error('Error al obtener configuración completa de Dropbox:', error);
      throw error;
    }
  },

  // Actualizar solo el token de acceso
  updateTokenOnly: async (accessToken) => {
    try {
      const response = await api.put('/dropbox/update-token', { accessToken });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar token de Dropbox:', error);
      throw error;
    }
  },

  // Guardar configuración completa de Dropbox (CRUD completo)
  saveFullConfig: async (configData) => {
    try {
      console.log('💾 Guardando configuración completa de Dropbox:', configData);
      
      // Si tiene ID, es una actualización (PUT), si no, es creación (POST)
      const method = configData.id ? 'put' : 'post';
      const endpoint = configData.id ? `/dropbox/config/${configData.id}` : '/dropbox/config';
      
      const response = await api[method](endpoint, configData);
      
      console.log('✅ Configuración guardada exitosamente:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al guardar configuración completa de Dropbox:', error);
      throw error;
    }
  }
};
